import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
// Mode: 'php' uses *.php scripts; 'rest' uses clean endpoints (/products, /categories, /contact)
const API_TYPE = (process.env.REACT_APP_API_TYPE || 'php').toLowerCase();

const apiClient = axios.create({
  baseURL: API_BASE_URL.replace(/\/$/, ''),
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

function ep(scriptName) {
  if (API_TYPE === 'rest') {
    // remove .php if present and ensure leading slash
    return '/' + scriptName.replace(/\.php$/i, '');
  }
  // php mode
  return '/' + (scriptName.endsWith('.php') ? scriptName : scriptName + '.php');
}

export const productService = {
  getAll: () => apiClient.get(ep('products.php')),
  getById: (id) => apiClient.get(`${ep('products.php')}${API_TYPE === 'rest' ? '/' + id : `?id=${id}`}`),
  // REST API does not yet support category filtering; perform client-side filter after fetching all
  getByCategory: async (categoryId) => {
    if (API_TYPE === 'php') {
      return apiClient.get(`${ep('products.php')}?category=${categoryId}`);
    }
    // REST mode: fetch all then filter
    const res = await apiClient.get(ep('products.php'));
    const filtered = Array.isArray(res.data)
      ? res.data.filter(p => p.categorie == categoryId || p.categorie === categoryId)
      : [];
    return { ...res, data: filtered };
  },
};

export const categoryService = {
  getAll: () => apiClient.get(ep('categories.php')),
  getById: (id) => apiClient.get(`${ep('categories.php')}${API_TYPE === 'rest' ? '/' + id : `?id=${id}`}`),
};

export const contactService = {
  send: (data) => apiClient.post(ep('contact.php'), data),
};

export default apiClient;
